import { CssDevice } from '@gig/magic-common';
import { DEVICE_QUERY, DEVICE_QUERY_IS_DESKTOP, DEVICE_QUERY_IS_TABLET, DEVICE_QUERY_IS_MOBILE, DEVICE_QUERY_IS_IOS, DEVICE_QUERY_IS_IPAD } from '@gig/magic-messages';
import { Device } from '@gig/magic-sdk/dist/methods/games';

class DeviceV2Service {
  constructor() {
    this.device = this.getDevice();
    this.registerDeviceQueries();
  }
  registerDeviceQueries() {
    window.queryBus.subscribe(DEVICE_QUERY, () => {
      return this.device;
    });
    window.queryBus.subscribe(DEVICE_QUERY_IS_DESKTOP, () => {
      return this.isDesktop();
    });
    window.queryBus.subscribe(DEVICE_QUERY_IS_TABLET, () => {
      return this.isTablet();
    });
    window.queryBus.subscribe(DEVICE_QUERY_IS_MOBILE, () => {
      return this.isMobile();
    });
    window.queryBus.subscribe(DEVICE_QUERY_IS_IOS, () => {
      return this.isIOS();
    });
    window.queryBus.subscribe(DEVICE_QUERY_IS_IPAD, () => {
      return this.isIpad();
    });
  }
  updateDevice(cssBreakpointsDevice) {
    this.cssBreakpointsDevice = cssBreakpointsDevice;
    this.device = this.getDevice();
  }
  getUserAgent() {
    return window && window.navigator.userAgent || "";
  }
  getMajorVersion(os, sp) {
    const userAgent = this.getUserAgent();
    const startString = userAgent.indexOf(os) + os.length;
    const endString = userAgent.indexOf(sp, startString);
    const version = userAgent.substring(startString, endString);
    return Number(version.trim().split(".")[0]) || null;
  }
  isPhone() {
    return this.cssBreakpointsDevice === CssDevice.MOBILE;
  }
  isTablet() {
    return this.cssBreakpointsDevice === CssDevice.PHABLET || this.cssBreakpointsDevice === CssDevice.TABLET;
  }
  isMobile() {
    return this.isPhone() || this.isTablet();
  }
  isDesktop() {
    return !this.isMobile();
  }
  isAndroid() {
    return /Android/i.test(this.getUserAgent());
  }
  isIOS() {
    return /iPhone|iPod|iPad/i.test(this.getUserAgent());
  }
  isIphone() {
    return /iPhone/i.test(this.getUserAgent());
  }
  isIpad() {
    return /iPad/i.test(this.getUserAgent());
  }
  isIPod() {
    return /iPod/i.test(this.getUserAgent());
  }
  isWM() {
    return /Windows Phone/i.test(this.getUserAgent());
  }
  isWM7() {
    return this.isWM() && this.getMajorVersion("Windows Phone OS", ";") === 7;
  }
  isWM8Plus() {
    return this.isWM() && this.getMajorVersion("Windows Phone", ";") >= 8;
  }
  isIosSafari() {
    return this.isIOS() && /Safari/i.test(this.getUserAgent());
  }
  getDevice() {
    if (this.isDesktop()) {
      return Device.DESKTOP;
    }
    if (this.isIphone()) {
      return Device.IPHONE;
    }
    if (this.isAndroid()) {
      if (this.isTablet()) {
        return Device.ANDROID_TABLET;
      }
      return Device.ANDROID;
    }
    if (this.isIpad()) {
      return Device.IPAD;
    }
    if (this.isIPod()) {
      return Device.IPOD;
    }
    if (this.isWM8Plus()) {
      return Device.WM8;
    }
    if (this.isWM7()) {
      return Device.WM7;
    }
    return void 0;
  }
}

export { DeviceV2Service };
